// @ts-nocheck
import { apiRequest } from "../../../services/apiService";
import {
  CLOSE_DIRECT_SMS_MODAL,
  CLOSE_REPORT_MODAL,
  CLOSE_SEND_SMS_MODAL,
  CLOSE_SEND_SMS_MODAL_WITH_HISTORY,
  CLOSE_SMS_MODAL,
  FETCH_OLDER_SMS_FAILURE,
  FETCH_OLDER_SMS_REQUEST,
  FETCH_OLDER_SMS_SUCCESS,
  FETCH_PEOPLE_FOR_SMS_FAILURE,
  FETCH_PEOPLE_FOR_SMS_REQUEST,
  FETCH_PEOPLE_FOR_SMS_SUCCESS,
  OPEN_DIRECT_SMS_MODAL,
  OPEN_REPORT_MODAL,
  OPEN_SEND_SMS_MODAL,
  OPEN_SEND_SMS_MODAL_DIRECT,
  OPEN_SMS_MODAL,
  REPORT_CONTRACTOR_FAILURE,
  REPORT_CONTRACTOR_REQUEST,
  REPORT_CONTRACTOR_SUCCESS,
  RESTRICT_CONTRACTOR_FAILURE,
  RESTRICT_CONTRACTOR_REQUEST,
  RESTRICT_CONTRACTOR_SUCCESS,
  SEND_SMS_FAILURE,
  SEND_SMS_REQUEST,
  SEND_SMS_SUCCESS,
  TRIGGER_EMAIL_CONSENT_FAILURE,
  TRIGGER_EMAIL_CONSENT_REQUEST,
  TRIGGER_EMAIL_CONSENT_SUCCESS,
  TRIGGER_SMS_CONSENT_FAILURE,
  TRIGGER_SMS_CONSENT_REQUEST,
  TRIGGER_SMS_CONSENT_SUCCESS,
  UNFLAG_CONTRACTOR_FAILURE,
  UNFLAG_CONTRACTOR_REQUEST,
  UNFLAG_CONTRACTOR_SUCCESS,
  UNRESTRICT_CONTRACTOR_FAILURE,
  UNRESTRICT_CONTRACTOR_REQUEST,
  UNRESTRICT_CONTRACTOR_SUCCESS,
} from "../../constants/sms/sms";
import { alertDialogAciton } from "../auth";

export const openSmsModalAction = () => {
  return { type: OPEN_SMS_MODAL };
};

export const closeSmsModalAction = () => {
  return { type: CLOSE_SMS_MODAL };
};

export const openSendSmsModalAction = () => {
  return { type: OPEN_SEND_SMS_MODAL };
};

export const openSendSmsModalDirectAction = (payload) => {
  return { type: OPEN_SEND_SMS_MODAL_DIRECT, payload };
};

export const closeSendSmsModalAction = () => {
  return { type: CLOSE_SEND_SMS_MODAL };
};

export const closeSendSmsModalWithHistoryAction = () => {
  return { type: CLOSE_SEND_SMS_MODAL_WITH_HISTORY };
};

/**
 * action to send sms
 */
export const sendSmsAction = ({
  payload,
  successCallback,
  failureCallback,
}) => {
  return async (dispatch) => {
    dispatch({ type: SEND_SMS_REQUEST });
    const { response, error } = await apiRequest({
      method: "PUT",
      url: "sendSms",
      data: payload?.data,
      params: payload?.params,
      isToken: true,
    });
    if (response?.status == 200) {
      dispatch({ type: SEND_SMS_SUCCESS });
      successCallback?.(response?.data?.message);
    } else if (response?.status !== 200 || error) {
      dispatch({ type: SEND_SMS_FAILURE });
      failureCallback?.(error?.response?.data?.message);
    }
  };
};

/**
 * action to fetch people for sms
 */
export const fetchPeopleForSmsAction = ({
  payload,
  successCallback,
  failureCallback,
}) => {
  return async (dispatch) => {
    dispatch({ type: FETCH_PEOPLE_FOR_SMS_REQUEST });
    const { response, error } = await apiRequest({
      method: "GET",
      url: "getAllAssignedUsersOfEvent",
      data: payload?.data,
      params: payload?.params,
      isToken: true,
    });

    if (response?.status == 200) {
      // Legacy BE v3 returned a `data: [users...]` array. v4/new returns
      // `data: { users, emailConsentNotAcceptedUsers, smsConsentNotAcceptedUsers }`.
      // Accept both to avoid the `people?.map is not a function` crash.
      const raw = response?.data?.data;
      const payload = Array.isArray(raw) ? raw : raw?.users || [];
      dispatch({
        type: FETCH_PEOPLE_FOR_SMS_SUCCESS,
        payload,
      });
      successCallback?.();
    } else if (response?.status !== 200 || error) {
      dispatch({ type: FETCH_PEOPLE_FOR_SMS_FAILURE });
      failureCallback?.();
    }
  };
};

// open report modal
export const openReportModalAction = ({ payload }) => {
  return { type: OPEN_REPORT_MODAL, payload };
};

export const closeReportModalAction = () => {
  return { type: CLOSE_REPORT_MODAL };
};

/**
 * report request action
 * payload.params = {contractorId: _id}
 */
export const reportContractorAction = ({
  payload,
  successCallback,
  failureCallback,
}) => {
  return async (dispatch) => {
    dispatch({ type: REPORT_CONTRACTOR_REQUEST });
    const { response, error } = await apiRequest({
      method: "PUT",
      url: "flagContractor",
      data: payload?.data,
      params: payload?.params,
      isToken: true,
    });

    if (response?.status == 200) {
      dispatch({ type: REPORT_CONTRACTOR_SUCCESS });
      successCallback?.(response?.data?.message);
    } else if (response?.status !== 200 || error) {
      dispatch({ type: REPORT_CONTRACTOR_FAILURE });
      failureCallback?.(error?.response?.data?.message);
    }
  };
};

/**
 * unflag request action
 * payload.params = {contractorId: _id}
 */
export const unflagContractorAction = ({
  payload,
  successCallback,
  failureCallback,
}) => {
  return async (dispatch) => {
    dispatch({ type: UNFLAG_CONTRACTOR_REQUEST });
    const { response, error } = await apiRequest({
      method: "PUT",
      url: "unFlagContractor",
      data: payload?.data,
      params: payload?.params,
      isToken: true,
    });

    if (response?.status == 200) {
      dispatch({ type: UNFLAG_CONTRACTOR_SUCCESS });
      successCallback?.(response?.data?.message);
    } else if (response?.status !== 200 || error) {
      dispatch({ type: UNFLAG_CONTRACTOR_FAILURE });
      failureCallback?.(error?.response?.data?.message);
    }
  };
};

/**
 * restrict request action
 * payload.params = {contractorId: _id}
 */
export const restrictContractorAction = ({
  payload,
  successCallback,
  failureCallback,
}) => {
  return async (dispatch) => {
    dispatch({ type: RESTRICT_CONTRACTOR_REQUEST });
    const { response, error } = await apiRequest({
      method: "PUT",
      url: "restrictContractor",
      data: payload?.data,
      params: payload?.params,
      isToken: true,
    });

    if (response?.status == 200) {
      dispatch({ type: RESTRICT_CONTRACTOR_SUCCESS });
      successCallback?.(response?.data?.message);
    } else if (response?.status !== 200 || error) {
      dispatch({ type: RESTRICT_CONTRACTOR_FAILURE });
      failureCallback?.(error?.response?.data?.message);
    }
  };
};

/**
 * unrestrict request action
 * payload.params = {contractorId: _id}
 */
export const unrestrictContractorAction = ({
  payload,
  successCallback,
  failureCallback,
}) => {
  return async (dispatch) => {
    dispatch({ type: UNRESTRICT_CONTRACTOR_REQUEST });
    const { response, error } = await apiRequest({
      method: "PUT",
      url: "unRestrictContractor",
      data: payload?.data,
      params: payload?.params,
      isToken: true,
    });

    if (response?.status == 200) {
      dispatch({ type: UNRESTRICT_CONTRACTOR_SUCCESS });
      successCallback?.(response?.data?.message);
    } else if (response?.status !== 200 || error) {
      dispatch({ type: UNRESTRICT_CONTRACTOR_FAILURE });
      failureCallback?.(error?.response?.data?.message);
    }
  };
};

/**
 * fetch older sms of that event
 * params: {eventId: objectId()}
 */
export const fetchOlderSmsAction = ({
  payload,
  successCallback,
  failureCallback,
}) => {
  return async (dispatch) => {
    dispatch({ type: FETCH_OLDER_SMS_REQUEST });
    const { response, error } = await apiRequest({
      method: "GET",
      url: "fetchSentSmsData",
      params: payload?.params,
      isToken: true,
    });

    if (response?.status == 200) {
      dispatch({ type: FETCH_OLDER_SMS_SUCCESS, payload: response?.data });
      successCallback?.(response?.data?.message);
    } else if (response?.status !== 200 || error) {
      dispatch({ type: FETCH_OLDER_SMS_FAILURE });
      failureCallback?.(error?.response?.data?.message);
    }
  };
};

/**
 * open direct sms modal action
 */
export const openDirectSMSModalAction = ({ payload }) => {
  return { type: OPEN_DIRECT_SMS_MODAL, payload };
};

/**
 * close direct sms modal action
 */
export const closeDirectSMSModalAction = () => {
  return { type: CLOSE_DIRECT_SMS_MODAL };
};

/**
 * action to trigget sms conset
 */
export const triggerSmsConsentAction = ({
  payload,
  successCallback,
  failureCallback,
}) => {
  return async (dispatch) => {
    dispatch({ type: TRIGGER_SMS_CONSENT_REQUEST });
    const { response, error } = await apiRequest({
      method: "PUT",
      url: "sendConsentSms",
      data: payload?.data,
      params: payload?.params,
      isToken: true,
    });

    if (response?.status == 200) {
      dispatch({ type: TRIGGER_SMS_CONSENT_SUCCESS });
      dispatch(
        alertDialogAciton({
          open: true,
          title: "Success",
          message: response?.data?.message || "Consent SMS send successfully.",
        }),
      );
      successCallback?.(response?.data?.message);
    } else if (response?.status !== 200 || error) {
      dispatch({ type: TRIGGER_SMS_CONSENT_FAILURE });
      dispatch(
        alertDialogAciton({
          open: true,
          title: "Failure",
          message:
            error?.response?.data?.message || "Failed to send consent email.",
        }),
      );
      failureCallback?.(error?.response?.data?.message);
    }
  };
};

/**
 * action to trigget email conset
 */
export const triggerEmailConsentAction = ({
  payload,
  successCallback,
  failureCallback,
}) => {
  return async (dispatch) => {
    dispatch({ type: TRIGGER_EMAIL_CONSENT_REQUEST });
    const { response, error } = await apiRequest({
      method: "POST",
      url: "sendDirectEmails",
      data: payload?.data,
      params: payload?.params,
      isToken: true,
    });

    if (response?.status == 200) {
      dispatch({ type: TRIGGER_EMAIL_CONSENT_SUCCESS });
      dispatch(
        alertDialogAciton({
          open: true,
          title: "Success",
          message:
            response?.data?.message || "Consent email send successfully.",
        }),
      );
      successCallback?.(response?.data?.message);
    } else if (response?.status !== 200 || error) {
      dispatch({ type: TRIGGER_EMAIL_CONSENT_FAILURE });
      dispatch(
        alertDialogAciton({
          open: true,
          title: "Failure",
          message:
            error?.response?.data?.message || "Failed to send consent email.",
        }),
      );
      failureCallback?.(error?.response?.data?.message);
    }
  };
};